// Central place for all external URLs used across the site.
export const LINKS = {
  docs:         "https://mtconnect.mintlify.app/",
  quickstart:   "https://mtconnect.mintlify.app/",
  apiRef:       "https://mtconnect.mintlify.app/",
  github:       "https://github.com/mtconnect",
  cppAgent:     "https://github.com/mtconnect/cppagent",
  slack:        "https://mtconnect.slack.com",
  mtcup:        "https://mtcup.org",
  modelBrowser: "https://model.mtconnect.org",
  officialSite: "https://www.mtconnect.org",
  amt:          "https://www.amtonline.org",
  contact:      "mailto:info@mtconnect.org",
  youtube:      "https://www.youtube.com/embed/PX6y9lKemR8?si=zQQpdJBXZsv9QbyZ",
  join:         "https://www.mtconnect.org/join",
  documents:    "https://www.mtconnect.org/documents",
  rd:           "https://www.mtconnect.org/r-d",
  opcUaCompanion: "https://www.mtconnect.org/opc-ua-companion-specification",
  playground:   "/playground.html",
};
